// Gate de ruta para Reportes Operativos — mismo patrón que
// RequireFinanceAccess.tsx, pero por perfil (admin_data.profile) en vez de
// una capacidad booleana: Picker y cualquier admin sin perfil asignado no
// entran. La autoridad real sigue siendo requireProfile en el backend
// (server/auth/roles.js) — esto solo evita renderizar del lado del cliente.
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ALLOWED = ["COORDINADOR", "LIQUIDACIONES", "ADMIN_TOTAL"];

export default function RequireReportsAccess() {
  const { adminProfile, capabilitiesLoading } = useAuth();

  if (capabilitiesLoading) {
    return null;
  }

  if (!adminProfile || !ALLOWED.includes(adminProfile)) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
